var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-part"},[_c('div',{staticClass:"welcome-section"},[_c('h1',{staticClass:"welcome-title"},[_vm._v("欢迎回来！")]),_c('p',{staticClass:"welcome-message"},[_vm._v("每一天都是新的开始，愿您在这里找到灵感与动力，继续创造美好的未来！")]),_c('p',{staticClass:"welcome-quote"},[_vm._v("“成功不是终点，失败也并非末日，最重要的是继续前进的勇气。” —— 温斯顿·丘吉尔")])])])
}]

export { render, staticRenderFns }